import cn from 'classnames';
import {
  CreateWarehouseStep,
  ICreateWarehouseStepProps,
} from '@@/warehouses/components/create-warehouse-step';

import styles from './styles.module.css';

export function WarehouseSize(props: WarehouseSizeProps) {
  const { className, size, hasIntersection, ...rest } = props;
  const rootClass = cn(styles.root, className);
  const sizeInHa = +((size ?? 0) / 10000).toFixed(2);
  return (
    <CreateWarehouseStep
      className={rootClass}
      next={{ disabled: !size || hasIntersection || sizeInHa > 100 || sizeInHa < 0 }}
      {...rest}
    >
      <p className={styles.text}>
        <span>размер выбранного участка:</span>
        <span className={styles.value}>
          {size ? `${Intl.NumberFormat('ru-RU').format(sizeInHa)} га` : '-'}
        </span>
      </p>

      {hasIntersection && <div className={styles.msg}>Склады пересекаются</div>}
      {sizeInHa > 100 && (
        <div className={styles.msg}>
          Размер поля превышает 100га - уменьшите размер поля
        </div>
      )}
      {sizeInHa < 0 && <div className={styles.msg}>Некорректный размер поля</div>}
    </CreateWarehouseStep>
  );
}

export interface WarehouseSizeProps extends ICreateWarehouseStepProps {
  size?: number;
  hasIntersection?: boolean;
}
